import React from "react"
import { AppFunctionComponent } from "../../../types"
import { uniqueId } from "lodash"

import { Svg } from "./arrow.styled"

export enum ArrowType {
  Next,
  Prev,
}

export interface ArrowProps {
  title: string
  arrowType: ArrowType
}

export const Arrow: AppFunctionComponent<ArrowProps> = ({
  className,
  arrowType,
  title,
}) => {
  const id = uniqueId()
  return (
    <Svg
      className={className}
      arrowType={arrowType}
      role="img"
      aria-labelledby={id}
    >
      <title id={id}>{title}</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-211.000000, -542.000000)" fillRule="nonzero">
          <g transform="translate(216.500000, 549.000000) scale(-1, 1) translate(-216.500000, -549.000000) translate(211.000000, 542.000000)">
            <polygon
              className="arrow-triangle"
              stroke="#FFFFFF"
              fill="#3B3F42"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="-9.09494702e-13 2 -9.09494702e-13 12 9.34797768 7"
            />
            <rect fill="#FFFFFF" x="9" y="0" width="2" height="14" rx="1" />
          </g>
        </g>
      </g>
    </Svg>
  )
}
